module.exports = __webpack_public_path__ + "img/15.a26a2e88.jpg";